<template>
  <v-dialog v-model="isOpen" width="300" class>
    <v-card class>
      <v-card-title>
        <span class="headline">{{$t('titles.sort')}}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-radio-group v-model="value" column>
            <v-radio color="primary" label="Date" value="date" class="class-radio"></v-radio>
            <v-radio color="primary" label="A-Z" value="a-z" class="class-radio"></v-radio>
          </v-radio-group>
        </v-container>
      </v-card-text>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="toggle">{{$t('buttons.close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      value: null
    };
  },
  computed: {
    isOpen: {
      get() {
        this.value = this.$store.getters["image/getFilter"];
        return this.$store.getters["dialogModal/isOpenSort"];
      },
      set() {
        this.toggle();
        return this.$store.getters["dialogModal/isOpenSort"];
      }
    },
  },
  methods: {
    toggle() {
      this.$store.dispatch("dialogModal/toggleSort");
    }
  },
  watch: {
    value(value) {
      this.$store.dispatch("image/filter", value);
    }
  }
};
</script>
<style scoped lang="sass">
.class-radio > label 
  margin: 0px
.headline
  margin: auto
.v-input
  justify-content: center

</style>
